import { DefaultState } from '@src/redux/types'

import { ASSESSMENT_FORMATIVE_CREATE, ASSESSMENT_FORMATIVE_LIST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ data: null, loading: false, error: null })

export const initialState: () => {
  [ASSESSMENT_FORMATIVE_CREATE]: DefaultState<`${typeof API.ASSESSMENT_FORMATIVE}`, 'post'>
  [ASSESSMENT_FORMATIVE_LIST]: DefaultState<`${typeof API.ASSESSMENT_FORMATIVE}`, 'get'>
} = () => ({
  [ASSESSMENT_FORMATIVE_CREATE]: defaultState(),
  [ASSESSMENT_FORMATIVE_LIST]: defaultState(),
})
